export default "__VITE_ASSET__CahkCATx__"